import { FormattersTypes } from '@/services/types/formatter'


export default ({ vtag, component, data, key, ctx }: FormattersTypes) => {

  component.tag = 'span';

  const getText = () =>{
    switch(data?.[key]) {
      case 0:
        return ctx.t('No');
      case 1:
        return ctx.t('Yes');
        default:
          return ctx.t('No');
    }
  }

  return vtag('div', {style: {}},
    [
        getText()
    ]
  );
}
